import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { RootState, useAppSelector } from '../../../store';
import { IChallenges } from '../../../backoffice/types/challenges';

export type backofficeChallengesState = {
    challenges: IChallenges[];
};

const initialState: backofficeChallengesState = {
    challenges: [],
};

    export const backofficeChallengesSlice = createSlice({
    name: 'backofficeChallenges',
    initialState,
    reducers: {
        setBackofficeChallenges: (state, action: PayloadAction<IChallenges[]>) => {
            state.challenges = action.payload;
        },
    },
});

export const { setBackofficeChallenges } = backofficeChallengesSlice.actions;
export const getBackofficeChallengesState = (state: RootState) => state.backoffice;
export const useBackofficeChallengesState = () => useAppSelector(getBackofficeChallengesState);

export default backofficeChallengesSlice.reducer;
